import { Button, Grid } from '@mui/material'
import CalculatePanel from 'components/Sell/CalculationInput/CalculatePanel'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'
import { useTranslation } from 'react-i18next'
import PaymentMobileDetail from '../PaymentMobileDetail'
import GroupIcon from '@mui/icons-material/Group'
import PaymentAccountDetail from 'components/Sell/payment/PaymentAccountDetail'
import PaymentDialogMobileContent from '../PaymentDialogMobileContent'
import FinishPaymentButton from '../FinishPaymentButton'
import { usePaymentCalculation } from 'components/Sell/payment/hook/usePaymentCalculation'

function CustomerAccountMobilePayment({
    onBack,
    onSubmitPayment,
}: {
    onBack: () => void
    onSubmitPayment: () => void
}) {
    const { t } = useTranslation()
    const {
        paymentDetail,
        quickButtons,
        tenderedAmount,
        onSetReceivedCash,
        onSetTenderedAmount,
        onOpenAccountDialog,
        selectedPaymentType,
        expectAmount,
        payment,
        isReadyToProceedPayment,
    } = usePaymentContext()

    const { isMoneyCollect } = usePaymentCalculation({
        selectedPaymentType,
        expectAmount,
        payment,
    })

    return (
        <PaymentDialogMobileContent
            onBack={onBack}
            topSection={
                <Grid
                    container
                    direction="column"
                    justifyContent={'space-between'}
                    spacing={1}
                >
                    <Grid item>
                        <CalculatePanel
                            paymentDetail={paymentDetail}
                            quickButtons={quickButtons}
                            initialValue={tenderedAmount.toNumber()}
                            onChange={(amount) => {
                                onSetReceivedCash(amount)
                                onSetTenderedAmount(amount)
                            }}
                            hideQuickButtons
                            minValue={0}
                        />
                    </Grid>
                    <Grid item>
                        <PaymentAccountDetail
                            paymentAccountName={
                                paymentDetail?.paymentAccount?.name ?? ''
                            }
                            paymentAccountBalance={
                                paymentDetail?.paymentAccount?.accountBalance ??
                                0
                            }
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            color="primary"
                            startIcon={<GroupIcon />}
                            onClick={onOpenAccountDialog}
                            fullWidth
                            style={{ marginBottom: 6 }}
                        >
                            {paymentDetail?.paymentAccount
                                ? t('quick_sell.label.change_account')
                                : 'Select Account'}
                        </Button>
                    </Grid>
                </Grid>
            }
            bottomSection={
                <Grid container direction="column">
                    <Grid item>
                        <PaymentMobileDetail />
                    </Grid>
                </Grid>
            }
            finishButton={
                <FinishPaymentButton
                    onConfirm={onSubmitPayment}
                    onCancel={onBack}
                    isMoneyCollect={isMoneyCollect}
                    isReadyToProceedPayment={isReadyToProceedPayment}
                />
            }
        />
    )
}
export default CustomerAccountMobilePayment
